var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 80V48C608 39.25 600.75 32 592 32H48C39.25 32 32 39.25 32 48V80C32 88.75 39.25 96 48 96V416C39.25 416 32 423.25 32 432V464C32 472.75 39.25 480 48 480H592C600.75 480 608 472.75 608 464V432C608 423.25 600.75 416 592 416V96C600.75 96 608 88.75 608 80ZM144 416H112V96H144V416ZM240 416H208V96H240V416ZM336 416H304V96H336V416ZM432 416H400V96H432V416ZM528 416H496V96H528V416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerStorage);
export default __webpack_public_path__ + "static/media/container-storage.a7c0868d579d7b129e2887dd0f1a60d9.svg";
export { ForwardRef as ReactComponent };